<div class="main about-us-page">
    <div class="container">
        <div class="white-bg">
            <div class="login-signup-box popout-register" id="deactivate" aria-labelledby="deactivateHeading">
                <div class="modal-body">
                    <div>
                        <form [formGroup]="loginForm">
                            <h1 id="deactivateHeading" class="h3">Account Deactivation</h1>
                            <div class="form-group mt-5">
                                <div class="text-box-wrap">
                                    <label for="deactivateEmail" class="sr-only">Email Address</label>
                                    <input type="email" id="deactivateEmail" autocomplete="email" formControlName="email" class="form-control"
                                        (keyup)="trimEmail()" [ngClass]="{'is-invalid': formErrors.email}"
                                        placeholder="Email Address" maxlength="50"
                                        [attr.aria-invalid]="formErrors.email ? true : null"
                                        [attr.aria-describedby]="fc.email.errors ? 'deactivateEmailErrors' : null">
                                    <div *ngIf="fc.email.errors" id="deactivateEmailErrors" class="invalid-feedback" role="alert">
                                        <div *ngIf="fc.email.errors.required">
                                            Please enter your Email Id
                                        </div>
                                        <div *ngIf="fc.email.errors.email">
                                            Please enter valid Email Id.
                                        </div>
                                    </div>
                                </div>

                            </div>
                        </form>
                        <div class="form-group">
                            <button type="button" [disabled]="!loginForm.valid" [ngStyle]="clientConfig.style.bg"
                                class="app-btn btn btn-danger" (click)="onSubmit()">Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>